module.exports = __webpack_public_path__ + "img/img_03.68162ae2.jpg";